import React from "react";

import { Sender } from "../consts";
import { Message } from "./Message";

export const ErrorMessage = ({ text }: { text: string }) => {
  return <Message text={text} sender={Sender.System} />;
};
